import { Button } from '@realtyka/real-ui';
import React from 'react';
import SimpleModal from './SimpleModal';

interface SimpleConfirmationModalProps {
  isOpen: boolean;
  question: string;
  onNo: () => void;
  onYes: () => void;
  noButtonText?: string;
  yesButtonText?: string;
  isSubmitting?: boolean;
  /**
   * Enable iOS WebView compatibility fixes
   * When true, applies GPU acceleration and h-screen for iOS WebView
   * Defaults to false to maintain backward compatibility
   */
  enableIOSWebViewFix?: boolean;
}

const SimpleConfirmationModal: React.FC<SimpleConfirmationModalProps> = ({
  isOpen,
  question,
  onNo,
  onYes,
  noButtonText = 'No',
  yesButtonText = 'Yes',
  isSubmitting = false,
  enableIOSWebViewFix = false,
}) => {
  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onNo}
      size='large'
      enableIOSWebViewFix={enableIOSWebViewFix}
    >
      <div className='bg-white'>
        <div className='flex items-center justify-center p-10'>
          <p className='font-inter text-base leading-6 text-center text-neutral-800'>
            {question}
          </p>
        </div>

        <div className='border-t border-black/10 px-6 py-6'>
          <div className='flex gap-3 justify-center'>
            <div className='w-[165px]'>
              <Button
                variant='outline'
                color='secondary'
                size='md'
                onClick={onNo}
                disabled={isSubmitting}
                fullWidth
              >
                {noButtonText}
              </Button>
            </div>

            <div className='w-[165px]'>
              <Button
                variant='filled'
                color='primary'
                size='md'
                onClick={onYes}
                disabled={isSubmitting}
                loading={isSubmitting}
                fullWidth
              >
                {yesButtonText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </SimpleModal>
  );
};

export default SimpleConfirmationModal;
